import { useLayoutEffect, type RefObject } from 'react';

/** Writes an element's height to a root CSS custom property. */
export function useMeasureCssVariable(
  ref: RefObject<HTMLElement | null>,
  variable: string,
  enabled = true,
): void {
  useLayoutEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const node = ref.current;
    if (!node) {
      return undefined;
    }

    const write = () => {
      document.documentElement.style.setProperty(variable, `${node.offsetHeight}px`);
    };

    write();
    const observer = new ResizeObserver(write);
    observer.observe(node);

    return () => observer.disconnect();
  }, [enabled, ref, variable]);
}
